import { ILoginGoogleBody, ILoginPostBody } from "../types/post/Interface";
import { postRequest } from "./NetworkService";
import { ILoginApiResp } from "../types/get/LoginType";
export const postUserLoginService = async (
  endPoint: string,
  requestBody: ILoginPostBody
) => {
  let { data }: { data: ILoginApiResp } = await postRequest(
    endPoint,
    requestBody
  );
  return data;
};

export const GoogleLoginService = async (
  endPoint: string,
  requestBody: ILoginGoogleBody
) => {
  let { data }: { data: any } = await postRequest(
    endPoint,
    requestBody
  );
  return data;
};